import {
  BarChart,
  Bar,
  XAxis,
  YAxis,
  Tooltip,
  ResponsiveContainer,
  CartesianGrid,
  Label
} from "recharts";
import { useNavigate } from "react-router-dom";

export default function CustomBarChart({  data, coachData } ) {
  const navigate = useNavigate();

  // Transform incoming object to chart array
  let chartData = Object.entries(data || {}).map(([key, value]) => ({
    name: key,
    Teacher: value.count,
    teacherIds: value.teacher_id || [], // include the array of teacher IDs
  }));

  // If no data, show a placeholder
  const isEmpty = chartData.length === 0;
  if (isEmpty) {
    chartData = [{ name: "No Data", Teacher: 0, teacherIds: [] }];
  }

  const maxValue = Math.max(...chartData.map(item => item.Teacher));
  const paddedMax = maxValue === 0 ? 1 : maxValue + 2;

  const handleBarClick = (barData) => {
    console.log("Clicked bar data:", barData);
    if (barData && barData.teacherIds.length > 0) {
      navigate("/coach-management/view-coach/TeacherArea", {
        state: {
          teacherIds: barData.teacherIds,
          coachData: coachData, // include full coachData here
        },
      });
    }
  };

  return (
    <div className="charts w-full h-[290px]">
      <ResponsiveContainer width="100%" height="100%">
        <BarChart
          data={chartData}
          margin={{ top: 10, right: 5, bottom: 15}}
        >
          <CartesianGrid strokeDasharray="3 3" />
          <XAxis dataKey="name">
            <Label
              value="Priority Area"
              offset={-8}
              position="insideBottom"
              style={{ fontSize: 12 }}
            />
          </XAxis>
          <YAxis domain={[0, paddedMax]} allowDecimals={false}>
            <Label
              value="No of Teachers"
              angle={-90}
              position="insideLeft"
              offset={4}
              style={{ textAnchor: "middle", fontSize: 12 }}
            />
          </YAxis>

          <Tooltip />

          <Bar
            dataKey="Teacher"
            fill="#994263"
            barSize={80}
            radius={[3, 3, 2, 0]}
            onClick={handleBarClick}
          />
        </BarChart>
      </ResponsiveContainer>
    </div>
  );
}

